import React, { useState } from 'react';
import { DateTime } from 'luxon';
import Hamburger from '../components/Hamburger';
// import './RSVP.css';

const API_URL = process.env.REACT_APP_API_URL;

const RSVP = () => {
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [showConfirmation, setShowConfirmation] = useState(false);
  const [submissionTime, setSubmissionTime] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [formData, setFormData] = useState({
    reservationid: '',
    first_name: '',
    lastName: '',
    attendance: ''
  });


  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    const submissionTimestamp = new Date().toISOString(); // always UTC
    const payload = {
      reservationid: formData.reservationid,
      first_name: formData.first_name,
      last_name: formData.lastName,
      attending: formData.attendance === 'yes',
      date_created: submissionTimestamp,
      last_updated: submissionTimestamp
    };
    try {
      const response = await fetch(`${API_URL}/api/reservations`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload)
      });
      
      if (response.ok) {
        setSubmissionTime(submissionTimestamp);
        setShowConfirmation(true);
        setFormData({ reservationid: '', first_name: '', lastName: '', attendance: '' });
      } else {
        throw new Error('Server responded with an error');
      }
    } catch (err) {
      console.error('Submission error:', err);
      alert('Failed to submit reservation. Please try again.');
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="background">
      <nav className="navbar">
        <Hamburger open={sidebarOpen} setOpen={setSidebarOpen} />
      </nav>
      <div> 
            <h2 className="home-header mb-4 pt-5">Let us know if you will be able to attend the baby shower!</h2>
        {showConfirmation && (
          <div className="alert alert-success text-center" role="alert" style={{maxWidth: '500px', margin: '0 auto'}}>
            <h4 className="mb-3">✅ Thank you for your RSVP!</h4>
            <p className="mb-2">Your reservation has been successfully submitted.</p>
            <small className="text-muted">
              <strong>Submitted on:</strong> {(() => {
                if (!submissionTime) return '';
                // Use luxon to convert UTC to Eastern and format
                const dt = DateTime.fromISO(submissionTime, { zone: 'utc' }).setZone('America/New_York');
                return dt.toFormat('yyyy-MM-dd HH:mm');
              })()}
            </small>
            <div className="mt-3">
            </div>
          </div>
        )}
        {!showConfirmation && (
          <form className="p-4 border rounded bg-light" style={{maxWidth: '400px', margin: '0 auto'}} onSubmit={handleSubmit}>
            <div className="mb-3">
              <label htmlFor="reservationid" className="form-label">Reservation ID</label>
              <input
                type="text"
                className="form-control"
                id="reservationid"
                placeholder="Enter your assigned reservation ID"
                value={formData.reservationid}
                onChange={e => setFormData({ ...formData, reservationid: e.target.value })}
                required
              />
            </div>
            <div className="mb-3">
              <label htmlFor="first_name" className="form-label">First Name</label>
              <input
                type="text"
                className="form-control"
                id="first_name"
                placeholder="Enter first name"
                value={formData.first_name}
                onChange={e => setFormData({ ...formData, first_name: e.target.value })}
                required
              />
            </div>
            <div className="mb-3">
              <label htmlFor="lastName" className="form-label">Last Name</label>
              <input
                type="text"
                className="form-control"
                id="lastName"
                placeholder="Enter last name"
                value={formData.lastName}
                onChange={e => setFormData({ ...formData, lastName: e.target.value })}
                required
              />
            </div>
            <div className="mb-3">
              <label className="form-label d-block mb-2">Will you attend?</label>
              <div className="form-check form-check-inline">
                <input
                  className="form-check-input"
                  type="radio"
                  name="attendance"
                  id="yes"
                  value="yes"
                  checked={formData.attendance === 'yes'}
                  onChange={e => setFormData({ ...formData, attendance: e.target.value })}
                  required
                />
                <label className="form-check-label" htmlFor="yes">Yes</label>
              </div>
              <div className="form-check form-check-inline">
                <input
                  className="form-check-input"
                  type="radio"
                  name="attendance"
                  id="no"
                  value="no"
                  checked={formData.attendance === 'no'}
                  onChange={e => setFormData({ ...formData, attendance: e.target.value })}
                  required
                />
                <label className="form-check-label" htmlFor="no">No</label>
              </div>
            </div>
            <div className="d-grid">
              <button 
                type="submit" 
                className="btn btn-primary btn-lg" 
                disabled={isSubmitting}
              >
                {isSubmitting ? (
                  <>
                    <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                    Submitting...
                  </>
                ) : (
                  '📝 Submit RSVP'
                )}
              </button>
            </div>
          </form>
        )}
      </div>
    </div>
  );
};

export default RSVP;